import { render, staticRenderFns } from "./previewImg.vue?vue&type=template&id=24486d4b&scoped=true&"
import script from "./previewImg.vue?vue&type=script&lang=js&"
export * from "./previewImg.vue?vue&type=script&lang=js&"
import style0 from "./previewImg.vue?vue&type=style&index=0&lang=css&"
import style1 from "./previewImg.vue?vue&type=style&index=1&id=24486d4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24486d4b",
  null
  
)

export default component.exports